import { useTranslation } from 'react-i18next';
import { t as translate } from 'i18n';
import React from 'react';
import Chip from '@mui/material/Chip';

const statusConfig = () => ({
  // Connection statuses
  pending:  { label: translate('shell.pending'),  color: 'default' },
  active:   { label: translate('shell.active'),   color: 'success' },
  error:    { label: translate('shell.error'),    color: 'error' },
  disabled: { label: translate('shell.disabled'), color: 'warning' },
  // Task statuses
  PENDING:  { label: translate('shell.queued'),   color: 'default' },
  STARTED:  { label: translate('shell.taskRunning'),  color: 'info' },
  SUCCESS:  { label: translate('shell.success'),  color: 'success' },
  FAILURE:  { label: translate('shell.failed'),   color: 'error' },
  REVOKED:  { label: translate('shell.cancelled'),color: 'warning' },
});

export default function StatusBadge({ status, size = 'small' }) {
  useTranslation();
  const cfg = statusConfig()[status] ?? { label: status, color: 'default' };
  return <Chip label={cfg.label} color={cfg.color} size={size} />;
}
